import {uniqueId} from 'lodash';
import React, {useEffect, useRef, useState} from 'react';
import {useMyAccount} from '../../../../../data/hooks/sessionHooks';
import useAnimatedVisibility from '../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';
import ContainedImage from '../../../../elements/ContainedImage';
import {useElementRect} from '../useProtectedRegions';
import styles from './InnerCircleCenterBubble.module.scss';
import strings from '../BubblesFilter/BubblesFilter.i18n.csv';
import {useLocalI18n} from '../../../../../data/hooks/i18nHooks';
import tinycolor from 'tinycolor2';

const InnerCircleCenterBubble = props => {
    const {className = '', event, filterParams, onProtectRegion, style} = props,
        {mounted, visible, showing, hiding, onTransitionEnd} = useAnimatedVisibility({
            visible: !!filterParams?.connections,
        }),
        user = useMyAccount(),
        [cid] = useState(uniqueId('c')),
        ref = useRef(),
        rect = useElementRect(ref),
        i18n = useLocalI18n(strings)

    useEffect(() => onProtectRegion(cid, rect), [rect, onProtectRegion]);
    useEffect(() => () => onProtectRegion(cid, null), [onProtectRegion]);

    if (!mounted) return null;

    return (
        <div
            className={[className, styles.InnerCircleCenterBubble, visible ? styles.visible : styles.hidden, showing || hiding ? styles.animated : ''].join(
                ' '
            )}
            onTransitionEnd={onTransitionEnd}
            style={style}>
            <div className={styles.protectedRegion} ref={ref} />
            <div className={styles.shade4} />
            <div className={styles.shade3} />
            <div className={styles.shade2} />
            <div className={styles.shade1} />
            <div className={styles.lighterBorder} />
            <div className={styles.darkerBorder} />
            <div className={styles.whiteBorder} />
            <div className={styles.bubble}>
                <ContainedImage src={user.image_url} altSrc="/img/no_avatar.png" />
            </div>
            <div className={styles.onlineBullet} />
            <div className={styles.label}>{i18n['inner-circle']}</div>
        </div>
    );
};

export default React.memo(InnerCircleCenterBubble);
